import React from "react";

function Schedule(){
    return(
        <div className=" flex justify-center items-center m-10">
            <div className=" shadow-xl shadow-black  rounded-md w-[700px]   text-center">
            <p className="font-extrabold lg:text-5xl italic">Schedule</p>
            <p className="text-justify ml-48 mt-10 text-gray-400 italic font-semibold text-xl">Friday</p>
            <p className="text-justify ml-5 text-gray-400 font-bold">_____________________________________</p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> 05:00 pm - 06:00 pm: Speech & opening ceremony</p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> 06:00 pm - 07:00 pm: Hackathon challenge begins</p>
            <p className=" text-justify m-5 mt-10 text-gray-400"> 07:00 pm - 10:00 pm: Coding Coding Coding !!!</p>
    

            <p className="text-justify ml-40 mt-10 text-gray-400 italic font-semibold text-xl">Saturday</p>
            <p className="text-justify ml-5 text-gray-400 font-bold">_____________________________________</p>
            <p className=" text-justify m-5  mt-10 text-gray-400"> 09:00 am - 10:00 am: Breakfast</p>
            <p className=" text-justify m-5  mt-10 text-gray-400"> 10:00 am - 4:00 pm: Coding Coding Coding !!!</p>
            <p className=" text-justify m-5  mt-10 text-gray-400"> 4:00 pm - 4:30 pm: Code submission</p>
            <p className=" text-justify m-5  mt-10 text-gray-400"> 4:30 pm - 6:00 pm: Judging period</p>
            <p className=" text-justify m-5  mt-10 text-gray-400"> 6:00 pm - 7:00 pm: Winners Announced!</p>

            </div>
            
        </div>
    )
}

export default Schedule;